if (!customElements.get('content-carousel')) {
  class ContentCarousel extends HTMLElement {
    constructor () {
      super();
      this.swiper = null;
    }

    connectedCallback () {
      if (window.Swiper !== undefined) {
        this.initSwiper();
      }
    }

    disconnectedCallback () {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }

    initSwiper () {
      const swiper_element = this.querySelector('.swiper');
      const slides_per_view = swiper_element.dataset.slidesPerView;
      const prev_button = this.querySelector('.swiper-button-prev');
      const next_button = this.querySelector('.swiper-button-next');

      this.swiper = new Swiper(swiper_element, {
        slidesPerView: 1.2,
        grabCursor: true,
        spaceBetween: 20,
        navigation: {
          nextEl: next_button,
          prevEl: prev_button
        },
        mousewheel: {
          forceToAxis: true
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: slides_per_view,
            grabCursor: false
          },
        },
      });
    }
  }

  customElements.define('content-carousel', ContentCarousel);
}